import { useMemo, useContext } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import AttributionKPIs from './AttributionKPIs';
const CONTEXTUAL_KPIS = [AttributionKPIs];
function useFetchContextualKPIs(baseReport, kpiLimit) {
  const userInfo = useContext(UserInfoContext);
  const contextualKpiReports = useMemo(() => CONTEXTUAL_KPIS.filter(({
    isSupported
  }) => isSupported({
    baseReport,
    userInfo
  })).map(({
    transform
  }) => transform({
    baseReport,
    kpiLimit
  })), [baseReport, kpiLimit, userInfo]);
  return contextualKpiReports;
}
export default useFetchContextualKPIs;